module.exports = __webpack_public_path__ + "img/lady5.93d49707.png";